import { z } from 'zod';
import { expectType } from './model.js';
import { EmptyPostBase, zFullPostBase, zPostBase } from './post.js';
export const zCommunityQuestionFields = z.object({
    postType: z.literal('communityQuestion')
});
export const zCommunityQuestion = zPostBase.merge(zCommunityQuestionFields);
expectType({});
expectType({});
export const zFullCommunityQuestion = zFullPostBase.merge(zCommunityQuestionFields);
expectType({});
expectType({});
export const EmptyCommunityQuestion = {
    ...EmptyPostBase,
    postType: 'communityQuestion'
};
